import React from 'react'
import { ListItemButton, ListItemIcon, ListItemText, Badge, Tooltip, Icon } from '@mui/material'
import { useThemeContext } from '../../theme/ThemeContext'
import { ExpandLess, ExpandMore } from '@mui/icons-material'

interface ButtonItemProps {
  title: string
  icon: string | React.ReactNode
  nested?: boolean
  notification?: React.ReactNode
  notificationColor?: any
  selected?: boolean
  open?:boolean
  openItem?: boolean
  subItem?: boolean
  onClick: () => void
}

const ButtonItem: React.FC<ButtonItemProps> = ({ title, icon, nested = false, notification, notificationColor, selected = false, open, openItem = false, subItem = false, onClick }) => {
  const { theme } = useThemeContext()
  return (
    <ListItemButton sx={{borderRadius: '8px', margin: open ? "14px" : "6px", marginLeft: subItem && open ? "32px" : "", backgroundColor: theme.palette.info.main,  // action.active
      //minHeight: 48,
      //justifyContent: openItem ? 'center' : 'initial',
      //px: 2.5,
      "&.Mui-selected": {
        backgroundColor: theme.palette.action.selected
      },
      ":hover": {
        backgroundColor: theme.palette.action.hover
      }
    }}
      
      dense
      selected={selected}
      onClick={onClick}
    >
      <Tooltip title={open ? '' : title}>
        <ListItemIcon sx={{minWidth: open ? 0 : "15px", mr: 1, justifyContent: 'center'}}>
            <Icon sx={{color: theme.typography.caption.color}}>{icon}</Icon></ListItemIcon>
      </Tooltip> 
      <Badge badgeContent={notification} sx={{ opacity: open ? 1 : 0, width: open ? 'fit-content' : 'unset' }} color={notificationColor ? notificationColor : "secondary"}>
        <ListItemText primary={title} sx={{ opacity: open ? 1 : 0 }} primaryTypographyProps={{variant:"subtitle1", whiteSpace:'normal', fontWeight:"medium"}} />
      </Badge>
      
      {nested && openItem ? <ExpandLess /> : nested && !openItem ? <ExpandMore />: <></>}
    </ListItemButton>
  )
}

export default ButtonItem